export default angular.module("routes", ["routes:mapping"]).config(function ($stateProvider) {
  $stateProvider
    .state("not-found", {
      url: "/not-found",
      templateUrl: "/maps/not-found.html",
    })
    .state("map", {
      url: "/{UUID:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}?lng&lat&zoom&view&legend&o",
      templateUrl: "/maps/map.html",
      controller: "map",
      resolve: {
        workspaces: function () {
          return {};
        },
        workspace: function () {
          return {};
        },
        entity: function () {
          return {};
        },
      },
    });
}).name;

require("./controllers/map");
